import { mountApp } from "./ui/app";

Office.onReady(() => {
  const sideloadMsg = document.getElementById("sideload-msg");
  const root = document.getElementById("app-root");
  if (sideloadMsg) sideloadMsg.style.display = "none";
  if (root) mountApp(root);
});
